import React from 'react';
import styled from 'styled-components';

const stats = [
  { number: '20+', label: 'Years of Experience' },
  { number: '500+', label: 'Projects Completed' },
  { number: 'LA', label: 'Los Angeles Based' },
];

const StatsSection = () => {
  return (
    <StatsContainer>
      <StatsGrid>
        {stats.map((stat, i) => (
          <StatItem key={i} $last={i === stats.length - 1}>
            <StatNumber>{stat.number}</StatNumber>
            <StatLabel>{stat.label}</StatLabel>
          </StatItem>
        ))}
      </StatsGrid>
    </StatsContainer>
  );
};

const StatsContainer = styled.section`
  background: #111827;
  padding: 56px 32px;
`;

const StatsGrid = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const StatItem = styled.div`
  text-align: center;
  padding: 20px 16px;
  border-right: ${({ $last }) => ($last ? 'none' : '1px solid #1f2937')};
  @media (max-width: 600px) {
    border-right: none;
    border-bottom: 1px solid #1f2937;
    &:last-child { border-bottom: none; }
  }
`;

const StatNumber = styled.div`
  font-family: "Poppins", sans-serif;
  font-size: 2.75rem;
  font-weight: 700;
  color: #c89432;
  line-height: 1;
  margin-bottom: 10px;
`;

const StatLabel = styled.div`
  font-family: "Poppins", sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #9ca3af;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

export default StatsSection;
